import React from 'react'
import styles from './hero.module.scss'
import { Col, Row } from 'antd'
import HeroTitle from '../../assets/img/01-Desktop-Text_Png2.png'
import HeroTitleMobile from '../../assets/img/01-mobile-Text_Png1.png'
import IphoneGift from '../../assets/img/01-Desktop-400-Webp2.png'
import IphoneGiftMob from '../../assets/img/01-Mobile-400-Webp1.png'
import HeroForm from './Form'
import { useMediaQuery } from 'react-responsive'

function Hero() {
  const isMobile = useMediaQuery({ maxWidth: 921 })

  return (
    <div id='world-cup-hero' className={styles.hero}>
      <div className=''>
        <Row className={styles.heroRow}>
          <Col
            xl={9}
            lg={8}
            md={24}
            sm={24}
            xs={24}
            className={styles.titleCol}
          >
            <img
              src={isMobile ? HeroTitleMobile : HeroTitle}
              alt='heroTitle'
              className={styles.heroTitle}
            />
          </Col>
          <Col
            xl={9}
            lg={8}
            md={24}
            sm={24}
            xs={24}
            className={styles.formCol}
          >
            {isMobile ? (
              <img
                src={IphoneGiftMob}
                alt='IphoneGift'
                className={styles.heroGraphic}
              />
            ) : (
              <HeroForm />
            )}
          </Col>
          <Col
            xl={6}
            lg={8}
            md={24}
            sm={24}
            xs={24}
            className={styles.graphicCol}
          >
            {isMobile ? (
              <HeroForm />
            ) : (
              <img
                src={IphoneGift}
                alt='IphoneGift'
                className={styles.heroGraphic}
              />
            )}
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default Hero
